var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowDeactiveicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7594 5.83329V4.49996C12.7594 4.14634 12.619 3.8072 12.3689 3.55715C12.1189 3.3071 11.7797 3.16663 11.4261 3.16663H3.42611C3.07248 3.16663 2.73335 3.3071 2.4833 3.55715C2.23325 3.8072 2.09277 4.14634 2.09277 4.49996V9.16663C2.09277 9.52025 2.23325 9.85939 2.4833 10.1094C2.73335 10.3595 3.07248 10.5 3.42611 10.5H8.75944",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42676 13.1666V10.5266V12.6266",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42676 13.1666H8.76009",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0934 8.5H12.7601C12.0237 8.5 11.4268 9.09695 11.4268 9.83333V13.8333C11.4268 14.5697 12.0237 15.1667 12.7601 15.1667H14.0934C14.8298 15.1667 15.4268 14.5697 15.4268 13.8333V9.83333C15.4268 9.09695 14.8298 8.5 14.0934 8.5Z",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowDeactiveicon);
export default __webpack_public_path__ + "static/media/window-deactiveicon.3a6500742c84a71d2389b0bd5c5137da.svg";
export { ForwardRef as ReactComponent };